import request from 'shared/lib/request';
import { API, RPC } from 'shared/constants';

const getById = (id, endpoint) => request({ url: `${endpoint}/${id}`, method: 'GET' });

const getFileById = (id, endpoint, version) =>
  request({
    url: version ? `${endpoint}/${id}?version=${version}` : `${endpoint}/${id}`,
    method: 'GET',
    headers: { Accept: 'application/vnd.kiron\\media' },
    responseType: 'blob',
    raw: true,
  });

const download = (id) =>
  request({
    url: `${RPC.DOWNLOAD}/${id}`,
    method: 'GET',
    responseType: 'blob',
    raw: true,
  });

const downloadAVC = (id) =>
  request({
    url: `${RPC.DOWNLOAD_AVC}/${id}`,
    method: 'GET',
    headers: { Accept: 'application/vnd.kiron\\media' },
    responseType: 'blob',
    raw: true,
  });

const downloadFatturaProvvigione = (id) =>
  request({
    url: `${API.FATTURA_PROVVIGIONE}/${id}`,
    method: 'GET',
    headers: { Accept: 'application/vnd.kiron\\media' },
    responseType: 'blob',
    raw: true,
  });

const downloadStoricoDiligence = (id) =>
  request({
    url: `${API.STORICO_DILIGENCE}/${id}`,
    method: 'GET',
    headers: { Accept: 'application/vnd.kiron\\media' },
    responseType: 'blob',
    raw: true,
  });

const AllegatoService = {
  getById,
  getFileById,
  download,
  downloadAVC,
  downloadFatturaProvvigione,
  downloadStoricoDiligence,
};

export default AllegatoService;



// WEBPACK FOOTER //
// ./app/shared/services/api/allegato/index.js